import React, { useState } from 'react';
import NavigationStepper, {
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import QuestionnaireList from '../../../../Components/QuestionnaireList/QuestionnaireList';
import PatientsFilledQuestionnairesList from '../PatientsFilledQuestionnairesList/PatientsFilledQuestionnairesList';
import QuestionnairePlanningModal from '../QuestionnairePlanning/QuestionnairePlanningModal';
import SubTabNavigationStepper from '../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepper';
import { QuestionnaireModule } from '../../Enums/QuestionnaireModule.enum';
interface Props {
	patientId: string;
	module?: QuestionnaireModule;
	roundValuesTo?: number;
}
const PatientsQuestionnaires: React.FC<Props> = ({
	patientId,
	module,
	roundValuesTo,
}) => {
	const [isQuestionnairePlanningOpen, setIsQuestionnairePlanningOpen] =
		useState<boolean>(false);
	const [refreshData, setRefreshData] = useState(false);

	const handleAfterQuestionnairePlanned = () => {
		setRefreshData(true);
		setRefreshData(false);
		setIsQuestionnairePlanningOpen(false);
	};

	const steps: NavigationStepperItemType[] = [
		{
			name: 'component.patientsQuestionnaires.planNewQuestionnaire',
			key: 'questionnaires',
			onClick: () => setIsQuestionnairePlanningOpen(true),
		},
		{
			name: 'component.patientsQuestionnaires.filledQuestionnaires',
			key: 'filledQuestionnaires',
			component: () => (
				<PatientsFilledQuestionnairesList
					patientId={patientId}
					module={module}
					roundValuesTo={roundValuesTo}
				/>
			),
		},
		{
			name: 'component.patientsQuestionnaires.plannedQuestionnaires',
			key: 'plannedQuestionnaires',
			component: () => (
				<QuestionnaireList
					patientId={patientId}
					showControls={false}
					toggleRefreshData={refreshData}
					filter={{ patientId: patientId }}
				/>
			),
		},
	];

	return (
		<>
			<SubTabNavigationStepper
				steps={steps}
				initialStepPath='filledQuestionnaires'
				canSkip={true}
				showStepNumbers={false}
			/>
			<QuestionnairePlanningModal
				opened={isQuestionnairePlanningOpen}
				onClose={handleAfterQuestionnairePlanned}
				patientId={patientId}
				module={module}
			/>
		</>
	);
};

export default PatientsQuestionnaires;
